import { Component, Inject } from '@angular/core';
import { NotificationToastService } from '../../../services/notification-toast.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-referring-physician-edit-dialog',
  templateUrl: 'referring-physician-edit-dialog.component.html',
})
export class ReferringPhysicianDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<ReferringPhysicianDialogComponent>
    , @Inject(MAT_DIALOG_DATA) public referringPhysicianId?: number) {
  }

  onClose($event): void {
    if (!$event) {
      this.dialogRef.close(false);
    } else {
      this.dialogRef.close($event);
    }
  }
}
